/*
 *
 * CreateDivisionModal reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_DIVISIONS_NO_PARENTS_SUCCESS,
  GET_DIVISIONS_NO_PARENTS_WATCHER,
  CREATE_DIVISION_WATCHER,
  CREATE_DIVISION_SUCCESS,
  CREATE_DIVISION_FAILED,
} from "./constants"

export const initialState = fromJS({
  divisionsNoParent: [],
  isLoadingCreate: false,
  reset: false,
})

function createDivisionModalReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_DIVISION_WATCHER:
      return state.set("isLoadingCreate", true).set("reset", false)
    case CREATE_DIVISION_SUCCESS:
      return state.set("isLoadingCreate", false).set("reset", true)
    case CREATE_DIVISION_FAILED:
      return state.set("reset", false).set("isLoadingCreate", false)
    case GET_DIVISIONS_NO_PARENTS_SUCCESS:
      return state.set("divisionsNoParent", action.payload)
    default:
      return state
  }
}

export default createDivisionModalReducer
